import React, { useContext } from 'react';
import { Drawer } from '@nextiva/next-ui-components';

import Header from './components/header';
import Step1 from './components/step1';
import Step2 from './components/step2';
import Confirmation from './components/confirmation';
import { ChimeContext, DispatchChimeContext, actionTypes } from './context';

const ChimeDrawer = () => {
  const {
    chimeSettings: { step, drawerState },
  } = useContext(ChimeContext);

  const chimeDispatch = useContext(DispatchChimeContext);

  const setDrawerStatus = (state) => {
    chimeDispatch({
      type: actionTypes.SET_CHIME_DRAWER_STATUS,
      state,
    });
  };

  const closeHandler = () => {
    setDrawerStatus(false);
  };

  return (
    <Drawer
      anchor="right"
      open={drawerState}
      relentless
      data-testid="PlatformAdminUI-ChimeDrawer-Drawer"
    >
      <div className="m-chime-drawer">
        <Header title="Video Settings" closeDrawer={closeHandler} />
        {step === 1 && <Step1 />}
        {step === 2 && <Step2 />}
        {step === 3 && <Confirmation />}
      </div>
    </Drawer>
  );
};

export default ChimeDrawer;
